<!--
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)

SPDX-License-Identifier: MPL-2.0
-->

<script lang="ts">
	import { onMount } from 'svelte';
	import '$lib/hljs.css';

	onMount(async () => {
		const { default: hljs } = await import('highlight.js/lib/common');
		hljs.highlightAll();
	});
</script>

<svelte:head>
	<title>ClassQuiz/docs - Privacy policy</title>
	<meta
		name="description"
		content="What ClassQuiz on quiz.kiberos.ai stores about you, for how long, and where"
	/>
</svelte:head>

<article
	class="prose prose-sm sm:prose lg:prose-lg xl:prose-xl mx-auto mt-10 prose-slate px-4 dark:prose-invert"
>
	<h1>Privacy Policy</h1>

	<h2>What gets stored for how long and why</h2>
	<table>
		<thead>
			<tr>
				<th>What?</th>
				<th>Why?</th>
				<th>How long?</th>
				<th>Where?</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td> The IP-Address of the user</td>
				<td>
					<ul>
						<li>To prevent abuse</li>
						<li>To provide user-sessions</li>
					</ul>
				</td>
				<td> For a very long time</td>
				<td>On our own server, hosted by Hostinger in the Netherlands.</td>
			</tr>
			<tr>
				<td> The data the user enters (quizzes, email, username)</td>
				<td> Self-explaining</td>
				<td>For as long as the account exists — you can delete it yourself in the account settings, and everything you created goes with it.</td>
				<td>On our own server, hosted by Hostinger in the Netherlands.</td>
			</tr>
			<tr>
				<td>The <b>hashed</b> password of the user</td>
				<td>Self-explaining</td>
				<td>For as long as the account exists — you can delete it yourself in the account settings, and everything you created goes with it.</td>
				<td>On our own server, hosted by Hostinger in the Netherlands.</td>
			</tr>
			<tr>
				<td>A random guest number and the name a player without an account uses</td>
				<td>To recognise the player in the next game and show their game history</td>
				<td>The number lives in the player's browser for up to 400 days; the history stays on the server. If the player creates an account, the history joins it; deleting the account removes the link.</td>
				<td>On our own server, hosted by Hostinger in the Netherlands.</td>
			</tr>
		</tbody>
	</table>

	<h2>Cookies</h2>
	<p>
		Cookies are used to store access-tokens, user-sessions, preferences and the guest number
		described above. They expire after a year (the guest number after 400 days).
	</p>

	<h2>Tracking</h2>
	<p>
		This instance collects no usage analytics at all: the visitor-tracking that upstream
		ClassQuiz ships was removed on 2026-08-26, and error-reporting to an external service is
		not configured either. Nothing about your visit leaves this server.
	</p>
	<h3>Third-Parties</h3>
	<p>
		None. This instance does not use a captcha or any other third-party service: avatars are
		drawn on our own server, and nothing is loaded from Google or other providers.
	</p>
</article>
